<script setup lang="ts">
import { useQuery } from '@tanstack/vue-query'
import TradingMonthAmount from './TradingMonthAmount.vue'
import { todayOverview } from '@mp/api/mchTradeData/BpCompanyIndexDashboardController.js'

const { data: overviewData } = useQuery({
  queryKey: ['statement/day/stat/trade/specifyDate/overview'],
  queryFn: () => todayOverview({}),
  select: data => data?.data,
})
</script>

<template>
  <section class="bg-white p-4 rounded-lg relative overflow-hidden mt-4" style="--el-border-color-light: transparent">
    <div class="flex justify-between">
      <label class="text-base text-n-800 flex font-medium">近30日交易金额及笔数</label>
    </div>

    <p class="text-n-90 text-xs">
      更新时间 {{ overviewData?.statTime }}
    </p>

    <TradingMonthAmount />
  </section>
</template>

<style scoped>
:deep(.el-tabs__item) {
  padding: 0 10px;
}
</style>
